/* ••[1]••••••••••••••••••••••••• TestimonialQuoteModel.ts •••••••••••••••••••••••••••••• */
import ProviderFactory from "../core/ProviderFactory";
import OcontentMiscProvider from "../core/providers/ocontent/OcontentMiscProvider";
import {
  OcontentProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";

import { TestimonialQuote } from "../core/types/TestimonialQuote";

export default abstract class TestimonialQuoteModel {
  private static testimonialQuoteCache: Array<TestimonialQuote>;
  private static miscProvider: OcontentMiscProvider = ProviderFactory.create(
    OcontentProviderType.Misc,
    ProviderConfiguration.ocontent
  );

  public static async getTestimonialQuoteData(): Promise<Array<TestimonialQuote> | null> {
    if (!TestimonialQuoteModel.testimonialQuoteCache) {
      TestimonialQuoteModel.testimonialQuoteCache =
        await TestimonialQuoteModel._getTestimonialQuoteData();
    }

    return TestimonialQuoteModel.testimonialQuoteCache;
  }

  private static async _getTestimonialQuoteData(): Promise<Array<TestimonialQuote> | null> {
    try {
      const items =
        await TestimonialQuoteModel.miscProvider.getTestimonialQuoteData();
      return items;
    } catch (err) {
      return null;
    }
  }
}
